import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Account Component, serves as a page wrapper for /account routes
 */
@Component({
  selector: 'b2c',
  templateUrl: './b2c.component.html',
  styleUrls: ['./b2c.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class B2cComponent {
  /**
   * @constructor
   */
  constructor() {}
}
